import React, { useEffect, useRef, useState } from "react";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  useDisclosure,
  Text,
  Input,
  Spacer,
  Button,
} from "@chakra-ui/react";
import { formatDate } from "../../utils";
import NoContentBox from "../common/NoContentBox";
import FlexRow from "../common/FlexRow";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown, faArrowUp, faFilter } from "@fortawesome/free-solid-svg-icons";
import ModalDialogue from "../common/ModalDialogue";

const QuestionnairesTable = ({ questionnaires }) => {
  const [sortOrder, setSortOrder] = useState("DESC");
  const [displayQuestionnaires, setDisplayQuestionnaires] = useState([]);
  const [indexedQuestionnaires, setIndexedQuestionnaires] = useState([]);
  const headers = [
    {
      title: "Week number",
      fieldName: "index",
      canFilter: false,
      dataType: "number",
    },
    {
      title: "Sending date",
      fieldName: "date",
      canFilter: false,
      dataType: "date",
    },
    {
      title: "Answer",
      fieldName: "answer",
      canFilter: true,
      dataType: "string",
    },
    {
      title: "Questionnaire status",
      fieldName: "status",
      canFilter: true,
      dataType: "string",
    },
  ];
  const {
    isOpen: isFilterOpen,
    onOpen: onOpenFilter,
    onClose: onCloseFilter,
  } = useDisclosure();
  const filterField = useRef(null);
  const filterText = useRef(null);
  const [hasFiltered, setHasFiltered] = useState(false);

  const onHeaderClick = (fieldName, dataType) => {
    const temp = [...displayQuestionnaires];
    if (dataType === "string") {
      temp.sort((a, b) => {
        if (sortOrder === "ASC") {
          return a[fieldName].localeCompare(b[fieldName]);
        }

        return b[fieldName].localeCompare(a[fieldName]);
      });
    } else {
      temp.sort((a, b) => {
        if (sortOrder === "ASC") {
          return a[fieldName] - b[fieldName];
        }
        return b[fieldName] - a[fieldName];
      });
    }
    setDisplayQuestionnaires([...temp]);
    setSortOrder(sortOrder === "ASC" ? "DESC" : "ASC");
  };

  const onFilterClick = (fieldName) => {
    filterField.current = fieldName;
    onOpenFilter();
  };

  const doFilter = () => {
    const text = filterText.current.value;
    if (text && text.length > 0) {
      const filtered = indexedQuestionnaires
        .filter(s => 
          s[filterField.current].toLowerCase().includes(text.toLowerCase()));
      setDisplayQuestionnaires([...filtered]);
      setHasFiltered(true);
    }
    onCloseFilter();    
  }
  
  useEffect(() => {
    if (questionnaires) {
      const indexed = questionnaires.map((q, i) => ({...q, index: i + 1}));
      setIndexedQuestionnaires(
        indexed
      );
      setDisplayQuestionnaires([...indexed]);
    }
  }, [questionnaires]);

  return (
    <>
        <>
        <ModalDialogue
        title="Filter questionnaires"
        onClose={onCloseFilter}
        isOpen={isFilterOpen}
        onMainAction={doFilter}
      >
        <Input type="text" ref={filterText} />
      </ModalDialogue>
      {hasFiltered && (
            <>
              <Spacer />
              <Button
                variant="outline"
                onClick={() => {
                  setDisplayQuestionnaires([...indexedQuestionnaires]);
                  setHasFiltered(false);
                }}
                colorScheme="orange"
              >
                Clear filter
              </Button>
            </>
          )}
        <TableContainer marginY={6} overflowX="unset" overflowY="unset">
          <Table variant="simple">
            <Thead backgroundColor="blue.100" position="sticky" top={0} zIndex="docked">
            {headers.map((header) => (
              <Th>
                <FlexRow>
                  <FontAwesomeIcon icon={faArrowUp} />
                  <FontAwesomeIcon icon={faArrowDown} />
                  <Text
                    cursor="pointer"
                    onClick={() => {
                      onHeaderClick(header.fieldName, header.dataType);
                    }}
                    marginLeft={2}
                  >
                    {header.title}
                  </Text>
                  {header.canFilter && (
                    <FontAwesomeIcon
                      icon={faFilter}
                      size="lg"
                      cursor="zoom-in"
                      onClick={() => {
                        onFilterClick(header.fieldName);
                      }}
                      style={{ marginLeft: "4px" }}
                    />
                  )}
                </FlexRow>
              </Th>
            ))}
            </Thead>
            <Tbody>
              {displayQuestionnaires.map(q => (
                <Tr>
                  <Td>{q.index}</Td>
                  <Td>{formatDate(q.date)}</Td>
                  <Td>{q.answer === 'N/A' ? 'Missing' : q.answer}</Td>
                  <Td>{q.status}</Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </TableContainer>
        </>
        {(!questionnaires || questionnaires.length === 0) && (
        <NoContentBox>No questionnaires have been generated</NoContentBox>
      )}
    </>
  );
};

export default QuestionnairesTable;
